export default __webpack_public_path__ + "static/media/logo.1202e051.PNG";